<h4 class="page-title">
  <button class="btn btn-outline-blue btn-rounded" (click)="voltar()" style="margin-right: 5px;">
    <i class="fa fa-arrow-left ct-point" ></i>
  </button>
  <i class="fas fa-table mr-1"></i> <span >Detalhes da Comanda</span></h4>

<div class="row" *ngIf="comanda">
  <form [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
        class="col-12"
        novalidate #frm="ngForm" (ngSubmit)="onSubmitFecharComanda($event)" >

    <div class="card  ">
      <div class="card-body">
        <div class="row mt-2">
          <div class="col-sm-6 col-12">
            <h4>Mesa: <strong>{{comanda.mesa.nome}}</strong>
              <span *ngIf="comanda.codigoPdv"> - Comanda {{comanda.codigoPdv}}</span>
            </h4>

            <h4>
             <span class="badge badge-pill ml-2" [class.badge-success]="!comanda.fechada"
                   [class.badge-dark]="comanda.fechada"> <i class="fe-user"></i>{{comanda.status}}</span>

              <div *ngIf="comanda.fechada" class="alert alert-dark mt-2">
                <i class="fe-lock mr-1"></i>
                <strong>Comanda Fechada</strong> - Não é possível realizar alterações
              </div>

              <h5 class="d-inline-block ml-2" [class.text-muted]="comanda.fechada">
                <span>Horário: <strong>{{comanda.horarioAberturaDescricao}}</strong> </span>
                <span *ngIf="comanda.horarioFechamentoDescricao"><strong> -  {{comanda.horarioFechamentoDescricao}}</strong></span>
              </h5>
            </h4>

            <div class="cartao-cliente-resumo" *ngIf="comanda.cartaoCliente as cartaoCliente">
              <div class="cartao-cliente-badge">
                <i class="fas fa-credit-card mr-2"></i>
                <span class="text-muted mr-1">Cartão cliente:</span>
                <strong>{{cartaoCliente.codigo || ('Cartão #' + cartaoCliente.id)}}</strong>
                <span class="badge badge-light ml-2" *ngIf="cartaoCliente.codigoPdv">
                  PDV {{cartaoCliente.codigoPdv}}
                </span>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-12">
            <info-contato [contato]="comanda.cliente" [exibirUltimaVisita]="false" [empresa]="empresa"></info-contato>
          </div>
        </div>

        <div class="mt-2">
          <app-grid-pedidos #gridPedidos [comanda]="comanda" [pedidos]="comanda.pedidos" [carregando]="carregando" [mesa]="true"
                            (onAtualizouComanda)="recarregueComanda($event)"   [editarPedido]="true"></app-grid-pedidos>
        </div>
      </div>
    </div>

    <div class="card mt-3" style="    max-width: 930px;">
        <div class="card-body">
          <div class="mb-1">
            <div class="row">
              <div class="col">

                <!-- Resumo de Valores Estilo PDV -->
                <div class="resumo-valores mb-3 p-3 bg-light rounded border">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="h5 mb-0 text-muted">Subtotal:</span>
                    <span class="h5 mb-0">{{comanda.valor | currency: 'BRL'}}</span>
                  </div>

                  <div class="d-flex justify-content-between align-items-center mb-2" *ngIf="desconto > 0">
                    <span class="text-danger font-weight-bold">Desconto:</span>
                    <span class="text-danger font-weight-bold">- {{desconto | currency: 'BRL'}}</span>
                  </div>

                  <div class="d-flex justify-content-between align-items-center mb-2" *ngIf="comanda.taxaServico > 0">
                    <span class="text-info">Taxa de Serviço:</span>
                    <span class="text-info">+ {{comanda.taxaServico | currency: 'BRL'}}</span>
                  </div>

                  <div class="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                    <span class="h3 font-weight-bold">Total a Pagar:</span>
                    <span class="h3 font-weight-bold text-success">{{totalDaComanda() | currency: 'BRL'}}</span>
                  </div>
                </div>

                <!-- Controles de Desconto e Taxa -->
                <div class="controles-valores mb-4 p-2 border rounded" [hidden]="comanda.fechada || comanda.emFechamento">
                  <div class="row align-items-end">
                    <div class="col-md-4 col-6">
                      <label class="font-weight-bold">Aplicar Desconto</label>
                      <div class="input-group" >
                        <div class="input-group-prepend" >
                          <div class="input-group-text p-0" style="padding-left: 15px !important; padding-right: 15px  !important;; ">
                            <button type="button" class="btn btn-sm" [class.btn-primary]="tipoDesconto === 'valor'" [class.btn-light]="tipoDesconto !== 'valor'" (click)="tipoDesconto = 'valor'; recalculeTotalComanda()">R$</button>
                            <button type="button" class="btn btn-sm" [class.btn-primary]="tipoDesconto === 'porcentagem'" [class.btn-light]="tipoDesconto !== 'porcentagem'" (click)="tipoDesconto = 'porcentagem'; recalculeTotalComanda()">%</button>
                          </div>
                        </div>
                        <kendo-numerictextbox name="valorDescontoInput"
                                              [format]="tipoDesconto === 'valor' ? 'c2' : obtenhaFormatoPercentual()"
                                              appRemovaWheel class="form-control"
                                              [disabled]="comanda.fechada"
                                              [(ngModel)]="valorDescontoInput"
                                              [min]="0"
                                              [max]="tipoDesconto === 'porcentagem' ? 100 : null"
                                              (ngModelChange)="recalculeTotalComanda()"
                                              placeholder="0,00">
                        </kendo-numerictextbox>
                      </div>
                    </div>

                    <div class="col-6 mt-2 mt-md-0" *ngIf="empresa.cobrarTaxaServico">
                      <div class="custom-control custom-checkbox custom-control-lg">
                        <input type="checkbox" class="custom-control-input" id="taxaServicoCheck"
                               name="taxaDeServico"
                               (change)="alterouCobarTaxa()"
                               [(ngModel)]="comanda.cobrarTaxaServico">
                        <label class="custom-control-label font-weight-bold  " for="taxaServicoCheck">
                          Cobrar taxa de serviço ({{empresa.valorTaxaServico}}%)
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Lista de Pagamentos Realizados (Visualização Melhorada) -->
                <div class="pagamentos-realizados mb-4" *ngIf="comanda.pagamentos.length > 0">
                  <h5 class="mb-3 text-muted"><i class="fas fa-wallet mr-2"></i>Pagamentos Realizados</h5>
                  <div class="list-group shadow-sm">
                    <div class="list-group-item d-flex justify-content-between align-items-center p-3" *ngFor="let pagamento of comanda.pagamentos">
                      <div class="d-flex align-items-center">
                        <div class="icon-pagamento mr-3 bg-light rounded-circle d-flex align-items-center justify-content-center" style="width: 45px; height: 45px;">
                          <i class="fas fa-money-bill-wave text-success fa-lg" *ngIf="pagamento.formaDePagamento.nome?.toLowerCase().includes('dinheiro')"></i>
                          <i class="fas fa-credit-card text-primary fa-lg" *ngIf="pagamento.formaDePagamento.nome?.toLowerCase().includes('crédito') || pagamento.formaDePagamento.nome?.toLowerCase().includes('credito')"></i>
                          <i class="fas fa-id-card text-info fa-lg" *ngIf="pagamento.formaDePagamento.nome?.toLowerCase().includes('débito') || pagamento.formaDePagamento.nome?.toLowerCase().includes('debito')"></i>
                          <i class="fas fa-qrcode text-dark fa-lg" *ngIf="pagamento.formaDePagamento.nome?.toLowerCase().includes('pix')"></i>
                          <i class="fas fa-wallet text-secondary fa-lg" *ngIf="!pagamento.formaDePagamento.nome?.toLowerCase().includes('dinheiro') && !pagamento.formaDePagamento.nome?.toLowerCase().includes('crédito') && !pagamento.formaDePagamento.nome?.toLowerCase().includes('débito') && !pagamento.formaDePagamento.nome?.toLowerCase().includes('pix')"></i>
                        </div>
                        <div>
                          <h6 class="mb-0 font-weight-bold text-dark">{{pagamento.formaDePagamento.descricao}}</h6>
                          <div class="small text-muted" *ngIf="pagamento.trocoPara">
                            Recebido: {{pagamento.trocoPara | currency: 'BRL'}} <span class="mx-1">|</span> Troco: <span class="text-danger">{{pagamento.valorTroco | currency: 'BRL'}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="text-right">
                        <span class="d-block font-weight-bold text-success h5 mb-0">{{pagamento.valor | currency: 'BRL'}}</span>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="form-group"
                     *ngIf="(comanda.aberta || comanda.emFechamento) && comanda.valor && !exibirPrefechamento">

                  <h4 *ngIf="comanda.emFechamento" class="mb-2">Comanda em <b>Pré fechamento</b> </h4>

                  <i class="k-icon k-i-loading mt-2"  *ngIf="carregandoFormasPagamentos"></i>

                  <form [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
                        novalidate #frm="ngForm" *ngIf="!carregandoFormasPagamentos">
                    <app-grid-pagamento #gridPagamentos  [frm]="frm" [pagamentoComanda]="true"
                                        [formasDePagamento]="formasPagamentoMesa" [totalPagar]="totalDaComanda()"
                                         >
                    </app-grid-pagamento>
                  </form>

                </div>

                <div class="botoes-acoes">
                  <div>
                    <button class="btn btn-blue btn-block mb-2" type="button" (click)="novoPedidoComanda()"
                            [disabled]="fechando" *ngIf="comanda.aberta && !fecharSemPrechamento">
                      <i class="fas fa-plus mr-1"></i> Novo Pedido
                    </button>
                  </div>

                  <div>
                    <button class="btn btn-warning btn-block mb-2" type="button" (click)="enviePreFechamento()"
                            *ngIf="exibirPrefechamento" [hidden]="fecharSemPrechamento" [disabled]="fechando">
                      <i class="k-i-loading k-icon mr-1" *ngIf="fechando"></i> Pré Fechamento
                    </button>
                  </div>

                  <ng-container *ngIf="(comanda.aberta || comanda.emFechamento)">
                    <div [hidden]="operador.garcom && !empresa.garcomFecharComandas">
                      <button class="btn btn-primary btn-block mb-2 btn-fechar-comanda" [disabled]="fechando"
                              *ngIf="!comanda.preFechamentoObrigatorio || comanda.emFechamento || fecharSomenteMeucardapio">
                        <span *ngIf="fechando" class="loading-spinner"></span>
                        <span *ngIf="!fechando"><i class="fas fa-check mr-1"></i></span>
                        Fechar Comanda
                      </button>
                    </div>

                    <div>
                      <button class="btn btn-outline-secondary btn-block mb-2" type="button" [hidden]="fecharSomenteMeucardapio"
                              (click)="cancelarFecharDireto()" *ngIf="fecharSemPrechamento" [disabled]="fechando">
                        Voltar
                      </button>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="comanda.aberta && !fecharSemPrechamento">
                    <div>
                      <button class="btn btn-blue btn-block mb-2" type="button" (click)="trocaMesa()" [disabled]="fechando">
                        <i class="fas fa-arrow-right mr-1"></i> Trocar Mesa
                      </button>
                    </div>
                  </ng-container>

                  <!-- Opções de impressão -->
                  <ng-container *ngIf="!configImpressao || !configImpressao.multiplasImpressoras">
                    <div  >
                      <button type="button" class="btn btn-outline-blue btn-block mb-2" *ngIf="configImpressao?.layoutPedido !== 'Ambos'"
                              (click)="imprimirComanda($event)" title="imprimir" kendoTooltip [disabled]="imprimindo">
                        <i class="fa fa-print"></i> Imprimir
                      </button>
                    </div>

                    <div  >
                      <kendo-dropdownbutton *ngIf="configImpressao?.layoutPedido === 'Ambos'"
                                          class="mb-2"
                                          [data]="opcoesImpressao"
                                          [popupSettings]="{animate: true}"
                                          (itemClick)="imprimirComanda($event)"
                                          [disabled]="imprimindo">
                        <i class="fa fa-print"></i> Imprimir
                      </kendo-dropdownbutton>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="configImpressao?.multiplasImpressoras && impressoras.length">
                    <div  >
                      <kendo-dropdownbutton class="mb-2"
                                          [data]="impressoras"
                                          [popupSettings]="{animate: true}"
                                          (itemClick)="imprimirComanda($event, true)"
                                          [textField]="'setor'">
                        <i class="fa fa-print"></i> Imprimir
                      </kendo-dropdownbutton>
                    </div>
                  </ng-container>
                </div>

                <div class="row mb-2" *ngIf="comanda.fecharNoParceiro" [hidden]="!comanda.aberta && !comanda.emFechamento">
                  <div class="form-group mb-2 col-7">

                    <div class="input-group mt-2">
                      <input name="fecharNoParceiro" id='fecharNoParceiro' class="k-checkbox  " kendoCheckBox
                             type="checkbox" [(ngModel)]="fecharSomenteMeucardapio" (change)="alterouFecharParceiro()" />
                      <label  class="k-checkbox-label" for="fecharNoParceiro">
                        Fechar somente no <b>Meucadapio</b> e ignorar fechamento no parceiro <b>{{empresa.integracaoDelivery?.sistema}}</b></label>


                    </div>

                  </div>
                </div>

                <div *ngIf="comanda?.pontosReceber" class="row mb-2">
                  <div class="col">
                    <i class="fe-star-on   text-blue"></i>
                    Pontuação Receber: <b>{{this.comanda.pontosReceber}}</b>
                  </div>
                </div>

                <div>
                  <div *ngIf="erro" class="alert alert-danger mt-2 mb-2" role="alert" [class.erro-entrada]="erroAnimando">
                    <i class="fas fa-exclamation-circle mr-2"></i>
                    {{erro}}
                  </div>

                </div>


              </div>
            </div>
          </div>

        </div>

    </div>

  </form>
</div>

<div class="alert alert-danger alert-dismissible fade show" *ngIf="carregou && comanda && !comanda.id" role="alert">
  <p>Comanda não encontrada</p>
  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="sucesso-fechamento" *ngIf="sucessoFechamento">
  <i class="fas fa-check-circle mr-2"></i>
  Comanda fechada com sucesso!
</div>


